import React, { lazy } from 'react';

const BankAccountLegacyForm = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/CompanySetupModule/BankAccountLegacyModule/BankAccountLegacyForm'
  ).then(module => ({ default: module.BankAccountLegacyForm })),
);

const BankAccountLegacyListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/CompanySetupModule/BankAccountLegacyModule/BankAccountLegacyListing'
  ).then(module => ({ default: module.BankAccountLegacyListing })),
);

const BankAccountLegacyDetail = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/CompanySetupModule/BankAccountLegacyModule/BankAccountLegacyDetail'
  ).then(module => ({ default: module.BankAccountLegacyDetail })),
);

//BANK ACCOUNT LEGACY
const bankAccountLegacyRoutes = [
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/bank-account-legacy/new',
    },
    component: <BankAccountLegacyForm mode="add" type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path: '/company-setup/submenu/:CompanyID/bank-account-legacy',
    },
    component: <BankAccountLegacyListing type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path:
        '/company-setup/submenu/:CompanyID/bank-account-legacy/detail/:bankAccountID',
    },
    component: <BankAccountLegacyDetail type="company-setup" />,
  },
  {
    props: {
      exact: true,
      path:
        '/company-setup/submenu/:CompanyID/bank-account-legacy/edit/:bankAccountID',
    },
    component: <BankAccountLegacyForm mode="edit" type="company-setup" />,
  },
];

export default bankAccountLegacyRoutes;
